import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { TOKENS } from '../state/colors';
import { diasHasta } from '../state/format';
import { BolsaCentro } from '../types';

interface UrgencyDotsProps {
  bolsas: BolsaCentro[];
}

export const UrgencyDots: React.FC<UrgencyDotsProps> = ({ bolsas }) => {
  return (
    <Box sx={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }} data-testid="urgency-dots">
      {bolsas.map((b) => {
        if (!b.validez) return null;
        const dias = diasHasta(b.validez);
        const color = dias <= 3 ? TOKENS.red : TOKENS.amber;
        return (
          <Tooltip key={b.id} title={b.codigo_cotizacion ?? b.id}>
            <Box sx={{ width: 11, height: 11, borderRadius: '50%', backgroundColor: color }} />
          </Tooltip>
        );
      })}
    </Box>
  );
};
